import React, { useEffect, useState } from 'react'
import { EmbeddedChatWindow } from '../components/EmbeddedChatWindow'

export const ChatbotEmbed: React.FC = () => {
  const [agentId, setAgentId] = useState<string>('')
  const [dimensions, setDimensions] = useState({ width: 400, height: 600 })

  useEffect(() => {
    // Send initial dimensions to parent
    window.parent.postMessage(JSON.stringify(dimensions), '*')

    // Listen for agent ID from parent
    const handleMessage = (event: MessageEvent) => {
      if (typeof event.data === 'string' && event.data.length === 24) {
        setAgentId(event.data)
      }
    }

    window.addEventListener('message', handleMessage)
    return () => window.removeEventListener('message', handleMessage)
  }, [dimensions])

  const handleResize = (newDimensions: { width: number; height: number }) => {
    setDimensions(newDimensions)
    window.parent.postMessage(JSON.stringify(newDimensions), '*')
  }

  if (!agentId) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        Loading chatbot...
      </div>
    )
  }

  return (
    <EmbeddedChatWindow
      agentId={agentId}
      onResize={handleResize}
    />
  )
}